module.exports = __webpack_public_path__ + "img/discovery_hover.c41ac5a9.png";